import { NextSeo, ArticleJsonLd } from "next-seo";
import { SEO } from "@/constants/index";
import { Article } from "@/graphql/gql/graphql";
import { publisherMarkup } from "@/utils/seo";

const ArticleSeo = ({ article }: { article: Article }) => {
  const { title, seo, thumbnailImageUrl, slug, hero } = article;

  const url = `${SEO.FANDUEL_URL_RESEARCH}/${slug}`;
  const openGraphTitle = seo?.openGraphTag?.title ?? title;
  const image =
    seo?.openGraphTag?.image?.url ??
    hero?.imageUrl?.url ??
    thumbnailImageUrl?.url;
  const images = image
    ? {
        images: [
          {
            width: 800,
            height: 600,
            alt: "Og Image Alt",
            type: "image/jpeg",
            url: image,
          },
        ],
      }
    : {};
  return (
    <>
      <NextSeo
        title={seo?.title ?? title}
        description={seo?.description ?? ""}
        canonical={seo?.canonicalUrl ?? url}
        noindex={!!seo.noIndex}
        openGraph={{
          title: openGraphTitle,
          url,
          description: seo?.description ?? "",
          ...images,
          type: "article",
          article: {
            publishedTime: article.firstPublishedAt ?? new Date().toISOString(),
          },
        }}
        twitter={{
          cardType: "summary_large_image",
        }}
      />
      <ArticleJsonLd
        useAppDir={false}
        url={`https://www.fanduel.com/research/${article.slug}`}
        title={seo?.title ?? title}
        description={seo?.description ?? ""}
        images={[image || ""]}
        datePublished={article.firstPublishedAt ?? new Date().toISOString()}
        dateModified={article.lastPublishedAt ?? undefined}
        image={[article.hero?.imageUrl]}
        authorName={[
          {
            name: article.author.name,
            url: `${SEO.FANDUEL_URL_RESEARCH}/author/${article.author.slug}`,
          },
        ]}
        headline={seo?.title ?? title}
        publisher={publisherMarkup}
        isAccessibleForFree
        mainEntityOfPage={{
          type: "WebPage",
          id: `${SEO.FANDUEL_URL_RESEARCH}/${article.slug}`,
        }}
        articleSection={article.sport}
      />
    </>
  );
};

export default ArticleSeo;
